import Hls from 'hls.js';
import { SMVP_ERROR } from '../error-handlers/smvp-error-handler';

export type ClientFacingHlsProvider = {
    ERROR_TYPES: Record<string, string>,
    ERROR_DETAILS: Record<string, string>,

    destroy: () => void,
    startLoad: () => void,
    stopLoad: () => void,
    recoverMediaError: () => void
}

export default function clientFacingHlsProvider(
    hls: Hls
): ClientFacingHlsProvider {
    return {
        ERROR_TYPES: { ...Hls.ErrorTypes },
        ERROR_DETAILS: { ...Hls.ErrorDetails, [SMVP_ERROR]: SMVP_ERROR },

        destroy: hls.destroy.bind(hls),
        startLoad: hls.startLoad.bind(hls),
        stopLoad: hls.stopLoad.bind(hls),
        recoverMediaError: hls.recoverMediaError.bind(hls)
    };
}
